import { useState } from 'react';
import { ScrollTrigger, useGSAP } from '../../lib/gsap';

/** Height of the reading line, as a share of the viewport, that decides the active section. */
const READING_LINE = '45%';

/**
 * Id of the section currently crossing the reading line, or null while the reader
 * is between tracked sections (hero, manifesto, marquee, contact).
 *
 * A section stays active until the element that follows it reaches the line, so
 * pin spacing added later by a chapter (Work, Vision) is covered. The triggers use
 * refreshPriority -1: they are measured after every pin of the page, whatever the
 * order in which the components created their ScrollTriggers.
 */
export function useActiveSection(ids: readonly string[]): string | null {
	const [active, setActive] = useState<string | null>(null);

	useGSAP(
		() => {
			ids.forEach((id) => {
				const section = document.getElementById(id);
				if (!section) return;
				const next = section.nextElementSibling;

				ScrollTrigger.create({
					trigger: section,
					start: `top ${READING_LINE}`,
					endTrigger: next ?? section,
					end: next ? `top ${READING_LINE}` : `bottom ${READING_LINE}`,
					refreshPriority: -1,
					onToggle: (self) => {
						const isActive = self.isActive;
						setActive((current) => (isActive ? id : current === id ? null : current));
					},
				});
			});
		},
		{ dependencies: [ids] },
	);

	return active;
}
